import { Button, Flex, Text } from '@radix-ui/themes'
import { TagIcon } from 'lucide-react'

import { AnnouncementBody, useJourney } from '../../journey'

import { vehiclePriceSpec } from './journey'
import { Simulator } from './Simulator'

import type { AnnouncementProps } from '../types'

/*
Tres frases, a pedido de los stakeholders: qué se agregó, que ya viene activado
y por dónde se cambia.

La versión anterior explicaba además que el precio se sigue viendo, que el
servidor también lo impide y que hay que volver a iniciar sesión. Todo cierto,
pero es una ficha técnica y esto es un aviso: quien necesite el detalle lo va a
ver en la pantalla de permisos, que es donde importa.
*/
export const Body = ({ active, onDismiss }: AnnouncementProps) => {
  const journey = useJourney(vehiclePriceSpec, active)

  return (
    <AnnouncementBody
      heading="Dónde está el permiso"
      blurb="El recorrido corto: Usuarios, el perfil de la persona y la casilla nueva."
      caption={journey.caption}
      stage={<Simulator state={journey} />}
      story={
        <>
          <Flex align="center" gap="2" className="mb-2 text-[#e5484d]">
            <TagIcon className="h-4 w-4" />
            <span className="font-mono text-[10px] font-bold uppercase tracking-wider">Usuarios · Permisos</span>
          </Flex>

          <p className="text-[15px] font-bold leading-snug text-[#1c1917]">
            Nuevo permiso para modificar el precio de los vehículos
          </p>

          <p className="mt-2 text-[13px] leading-relaxed text-[#706d71]">
            Todos los usuarios lo tienen habilitado por defecto, así que nada cambia.
          </p>

          <p className="mt-2 text-[13px] leading-relaxed text-[#706d71]">
            Si quiere que alguien no pueda cambiar precios, vaya a <strong className="text-[#1c1917]">Usuarios</strong>,
            abra su perfil y desmarque <strong className="text-[#1c1917]">Modificar precio de vehículos</strong>. El
            precio se sigue viendo; solo deja de poder editarse.
          </p>

          <Flex justify="end" className="mt-6">
            <Button size="2" color="red" onClick={onDismiss}>
              <Text weight="bold">Entendido</Text>
            </Button>
          </Flex>
        </>
      }
    />
  )
}
